import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { fromEvent, Subscription } from 'rxjs';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { debounce, debounceTime, first } from 'rxjs/operators';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHub } from 'src/app/services/gameHub/game-hub';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { TimeService } from 'src/app/services/time-service/time.service';


import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from '../menu/navigator';
import { Platform } from '@ionic/angular';


@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit,AfterViewInit {
  public showRecentPlayedGames:boolean;
  public game_height: object = {};
  public show: boolean = true;
  public timeOnlineEnabled: boolean;
  public showTimeOnline: boolean;
  public showNetPosition:boolean;
  public isMobile: boolean;
  public isMobileOrMobileWeb: boolean;
  public isMobileWeb: boolean;
  public isCordova: boolean;
  public isCapacitor: boolean;
  public isIOSApp: boolean;
  public windowResizeSubscription: Subscription;
  public instanceId: string;
  public showPreloader: boolean = true;
  public onlineTimeInterval: ReturnType<typeof setInterval>;
  public timeOnline: string;
  public gameURL: SafeResourceUrl;
  public gameNotFound: string = null;
  public showMyGamesPane: boolean = true;
  public customer: CustomerModel;
  public isAuthenticated: boolean;
  public isDemoGame: boolean = false;
  public backButtonSubscribtion: Subscription;
  public dataToDisplay: string;
  public netPositionDelay: any;
  public netWinOperator: string = "+";
  public netWinAmount:string = '0.00';
  public isClosed: boolean = false;
  public gameStopped: boolean = false;
  constructor(
    private gameHubService: GameHub,
    private eventsService: EventsService,
    private sanitizer: DomSanitizer,
    private userSessionService: UserSessionService,
    private lobbyService: LobbyService,
    public navigator: Navigator,
    private config:ConfigService,
    public webservices : WebservicesService,
    private gameHubControllerService: GameHubControllerService,
    private timeService:TimeService,
    private lobbyNavigator:LobbyNavigator,
    private childElement: ElementRef,
    public platform: Platform
  ){
    this.userSessionService
      .getCustomerSubscription()
      .then((customerSubject) =>
        customerSubject.subscribe((customer) => (this.customer = customer))
      );
    this.userSessionService
      .isAuthenticated()
      .then((isAuthenticated) => (this.isAuthenticated = isAuthenticated));

    this.backButtonSubscribtion = platform.backButton.subscribeWithPriority(101, () => {
      console.log("game component: backButton subscribeWithPriority")
      this.onCloseBtn();
    });

    this.netPositionDelay = this.config.getConfig().FEATURE_NET_POSITION_DELAY || '0';
    this.eventsService.subscribe('event:GameStats:Response', (data) => {
      console.log('-----received-------',data)
      //By default, netPosition will hold 0.00. We will push the currentValue in array. But, we always display previousValue for netWinAmount.
      //this.netPosition.push(data)
      //we always display previousValue for netWinAmount which is 0 index in our case.
      //this.dataToDisplay = this.netPosition[0];
      //Adjusted call to display +/- and have to change type from number to string to display default value 0.00
      this.dataToDisplay = data;
      let timeout = 0;
      if(this.netPositionDelay) {
        if(this.netPositionDelay == 0){
          timeout = 0;
        } else {
          timeout = this.netPositionDelay * 1000;
        }
      }
      //configurable delay to display Net Position on UI
      setTimeout(() => {
        if(this.dataToDisplay.startsWith('-')) {
          this.netWinOperator = "-";
          this.netWinAmount = this.dataToDisplay.substring(1);
        } else {
          this.netWinOperator = "+";
          this.netWinAmount = this.dataToDisplay;
        }
        console.log('-----displaying-----', this.netWinAmount)
      }, timeout );
      //After displaying netWinAmount remove the previousValue, So we have alway one value which will be previousValue based on logic.
      //this.netPosition.shift();
      //console.log('-----stored-----', this.netPosition)
    });
    this.messageEventListener = this.messageEventListener.bind(this);

   }

   ngOnInit() {
    this.showRecentPlayedGames =  this.config.getConfig().FEATURE_SHOW_RECENT_PLAYED_ON_GAME_PAGE ?? 0;
    if (this.isMobileOrMobileWeb) {
      this.showTimeOnline =  this.config.getConfig().FEATURE_SHOW_TIME_ONLINE ?? 0;
    }

    this.showNetPosition = this.config.getConfig().FEATURE_SHOW_NET_POSITION ?? 0;
    if(this.isCapacitor){
      this.eventsService.publish("event:bottommenu:hide")
    }

     // this.setPlatforms is called from games component
    this.onWindowResize();

    setTimeout(() => {
      this.showPreloader = false;
    }, 1000);

    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement) {
        this.clearMobileLook();
        console.log('Leaving full-screen mode.');
      }
    });

    window.addEventListener('message', this.messageEventListener, false);

    if (this.showTimeOnline) {
      if (this.onlineTimeInterval) {
        clearInterval(this.onlineTimeInterval);
        this.onlineTimeInterval = null;
      }

      this.timeOnline = this.timeService.getOnlineTime() || '';
      this.onlineTimeInterval = setInterval(() => {
        this.timeOnline = this.timeService.getOnlineTime() || '';
      }, 30000);
    }
    this.eventsService.subscribe("game:fullscreen:exit",()=> {
      this.toggleFullScreen(true);
    });
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 500)
  }

  //After Game Componenet is created and view becomes visible set the game Height
  ngAfterViewInit(){
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.onlineTimeInterval);
    this.onlineTimeInterval = null;
    this.onCloseBtn();
    if(this.windowResizeSubscription) {
      this.windowResizeSubscription.unsubscribe();
    }
    if(this.backButtonSubscribtion) {
      this.backButtonSubscribtion.unsubscribe();
    }
  }

  ionViewDidEnter() {
    this.onWindowResize();
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 0)
  }
  ionViewWillLeave() {
    console.log('view will leave');
    if (this.isMobile) {
      this.clearMobileLook();
    }

    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();

    this.gameHubService.muteAllGames();
    this.gameHubService.unfocusInstance(this.instanceId);
  }

  private onWindowResize = () => {
    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();
     this.windowResizeSubscription = fromEvent(window, 'resize').pipe(debounceTime(100)).subscribe(
       (event) => {
         // add debounce 100 ms

        this.setPlaceholderHeight();
        this.iframePostMessage({ message: 'IFRAME_RESIZE'});
       }
     );
  };

  private iframePostMessage(message){
    let iframe = this.getIframe();
    if(iframe) iframe.postMessage( JSON.stringify( message), '*');
    console.log("message", message);
  }

  private getIframe() {
    let elem = this.childElement.nativeElement.getElementsByTagName('iframe')[0];
    let iframe = elem?.contentWindow;
    return iframe;
  }

  private messageEventListener(event) {
    if (!isUndefined(event.data)) {
      this.handleGameEvents(event.data);
    }
  }

  private handleGameEvents(eventData) {
    try {
      const data = (typeof eventData === 'object') ? eventData : JSON.parse(eventData);

      if (data && data._type === "nw2Lobby.closegame.CloseGameResponse") {
        if (!this.isClosed) {
          this.gameCloseService();
        }
      }
    } catch (error) {
      console.log("handleGameEvents Error: ", error)
    }
  }

  public setPlaceholderHeight() {
    if (this.isMobileOrMobileWeb) {
      this.setMobileLook();
    } else {

      let topGameNavigationButtonElement: any = document.querySelector("ion-col.game-wrapper-bar");
      console.log('topGameNavigationButtonElement ----', topGameNavigationButtonElement)
      let topGameNavigationButtonHeight: any = !!topGameNavigationButtonElement ? topGameNavigationButtonElement.offsetHeight : 50;
      console.log('topGameNavigationButtonHeight ----', topGameNavigationButtonHeight);
      let headerElement: any = document.querySelector("app-site-header");
      console.log('headerElement ----', headerElement)
      let headerHeight: any = !!headerElement ? headerElement.offsetHeight : 0;
      console.log('headerHeight ----', headerHeight)
      // let searchElement: any = document.querySelector("ion-grid.lobby-bar");
      // console.log('searchElement ----', searchElement, "Height: "+searchElement.offsetHeight)
      // let searchHeight: any = !!searchElement ? searchElement.offsetHeight : 0;
      // console.log('searchHeight ----', searchHeight);

      //Adding 10px to adjust extra padding which i have to figure out for style so, don't have to use fixed value
      let height =
        window.innerHeight - headerHeight  - topGameNavigationButtonHeight - 10;
        console.log('window.innerHeight ----', window.innerHeight)
        console.log('height ----', height)
      this.game_height = { height: `${height}px` };
    }

    if(!this.isIOSApp || (this.platform.is('ipad') && !this.isCapacitor)) {
      this.changeCssToAvoidBrowserLoadingBug();
    }
  }

  changeCssToAvoidBrowserLoadingBug() {
    let tabbar = document.querySelector('body');
    let q = 100;
    let x = setInterval(() => {
      if (!!tabbar) tabbar.setAttribute('style', `max-width: ${q}%`);
      q = q == 100 ? 101 : 100;
    }, 100);

    setTimeout(() => {
      clearInterval(x);
    }, 3000);
  }

  showGame(show: boolean) {
    this.show = show;
  }

  setInstanceId(instanceId) {
    console.log(instanceId);

    this.instanceId = instanceId;
  }

  setGameUrl(url, session_token, isDemo) {
    // let deviceType = this.gameHubControllerService.getDeviceType();
    // if(!session_token || isDemo) {
    //   this.isDemoGame = true;
   // this.gameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url + '&windowID=' + this.instanceId);
    //   return;
    // }

    let deviceType = this.gameHubControllerService.getDeviceType();
    let obj: any = {
      session_token:session_token
    }
    this.webservices.getApiNoRedirect(url, deviceType, obj).pipe(first()).subscribe(
      resp => {
        if (!!resp.result && resp.payload) {
          this.lobbyService.clearWaitingGameData();

          let url = '';
          if ('href' in resp.payload) url = resp.payload.href;
          if ('src' in resp.payload) url = resp.payload.src;
          this.gameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url + '&windowID=' + this.instanceId);
        } else {
          this.gameNotFound = this.config.getConfig().FEATURE_DISPLAY_GAME_LAUNCH_ERROR ? this.config.getConfig().FEATURE_DISPLAY_GAME_LAUNCH_ERROR : 'Sorry, something went wrong when trying to launch a game.';
        }
      }, (error) => {
        console.log("Error occurred:", error.error_code);
        if (error.error_code === "PLAYER_HAS_ACTIVE_BONUS_CANNOT_USED_BY_GAME") {
          localStorage.setItem('skipActiveBonusCheck', 'true');
          this.onCloseBtn();
          this.navigator.openPopover(
            "RestrictedMoneyPopover",
            { message: '' }, "standard-popover",
            true, true, true, -1, 'cover', true
          );
          return;
        }
        this.gameNotFound = this.config.getConfig().FEATURE_DISPLAY_GAME_LAUNCH_ERROR ? this.config.getConfig().FEATURE_DISPLAY_GAME_LAUNCH_ERROR : 'Sorry, something went wrong when trying to launch a game.';
      }
    )
  }

  public setPlatforms(platforms) {
    this.isMobile = platforms.isMobile;
    this.isMobileOrMobileWeb = platforms.isMobileOrMobileWeb || platforms.isCapacitor;
    this.isMobileWeb = platforms.isMobileWeb;
    this.isCordova = platforms.isCordova;
    this.isCapacitor = platforms.isCapacitor;
    this.isIOSApp = platforms.isIOSApp;
  }

  toggleFullScreen(exit: boolean = false) {
    var doc: any = window.document;
    var docEl: any = doc.documentElement;
    var requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    var cancelFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (!!exit) {
      this.clearMobileLook();
      if (
        doc.fullscreenElement ||
        doc.webkitFullscreenElement ||
        doc.mozFullScreenElement
      ) {
        cancelFullScreen.call(doc).catch((error) => {
          console.log(error);
        });
        // can use exitFullscreen
      }

      return false;
    }
    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      this.setMobileLook();
      requestFullScreen.call(docEl);
    } else {
      this.clearMobileLook();
      cancelFullScreen.call(doc);
    }
  }

  private clearMobileLook() {
    let scrollContent = document.querySelector('app-game');
    let topHeaderEl: any = document.querySelector('ion-toolbar');
    let keywordsComponent = document.getElementsByTagName('app-site-header')[0];

    if (!!keywordsComponent)
      keywordsComponent.setAttribute('style', 'display:block');

    let lastPlayed = document.getElementById('my_games');
    if (!!lastPlayed)
    lastPlayed.setAttribute('style', 'display:block;padding-top: 0px; padding-bottom: 0px; flex: 0 0 calc(calc(2 / var(--ion-grid-columns, 12)) * 100%); width: calc(calc(2 / var(--ion-grid-columns, 12)) * 100%); max-width: calc(calc(2 / var(--ion-grid-columns, 12)) * 100%);');


    if (!!scrollContent)
      scrollContent.setAttribute('style', 'overflow-y: auto;');
    if (!!topHeaderEl) topHeaderEl.setAttribute('style', 'display:block');
    this.showMyGamesPane = true;
  }

  public setMobileLook() {
    let topHeaderEl: any = document.querySelector('ion-toolbar');
    let tabbar = document.querySelector('.tabbar');
    let scrollContent = document.querySelector('games-home .scroll-content');
    let keywordsComponent = document.getElementsByTagName('app-site-header')[0];

    let lastPlayed = document.getElementById('my_games');
    if (!!lastPlayed)
    lastPlayed.setAttribute('style', 'display:none');
    let gameBarElement: any = document.querySelector(
      'ion-row.control-bar-reversed-columns'
    );
    let gameBarHeight: any = !!gameBarElement ? gameBarElement.offsetHeight : 0;
    let topGameNavigationButtonElement: any = document.querySelector("ion-col.game-wrapper-bar");
    let topGameNavigationButtonHeight: any = !!topGameNavigationButtonElement ? topGameNavigationButtonElement.offsetHeight : 50;
    console.log('topGameNavigationButtonHeight ----', topGameNavigationButtonHeight);
    if(this.gameStopped){
      keywordsComponent.setAttribute('style', 'display:block');
    } else if (!!keywordsComponent)
      keywordsComponent.setAttribute('style', 'display:none');
    if (!!topHeaderEl) topHeaderEl.setAttribute('style', 'display:none');
    if (!!tabbar) tabbar.setAttribute('style', 'display:none');
    this.showMyGamesPane = false;
    if (!!gameBarElement) gameBarElement.setAttribute('style', 'display:none');
    if (!!scrollContent) {
      scrollContent.setAttribute('style', 'overflow-y: hidden;');
      scrollContent.setAttribute('style', 'margin-top: 0!important;');
    }
    //Adding 500ms delay so, when phone is roated in landscape view (while game is already running), it will adjust window height properly
    setTimeout(() => {
      let height = window.innerHeight - gameBarHeight - topGameNavigationButtonHeight;
      this.game_height = { height: `calc(${height}px - env(safe-area-inset-bottom) ${this.isIOSApp ? '- env(safe-area-inset-top)' : '- 10px'})` };
    }, 500);
    window.scrollTo(0, 0);
  }

  onCloseBtn() {
    this.gameStopped = true;
    this.gameCloseService();
    //this.navigator.toCasino();
    this.lobbyNavigator.selecHomeIfnotGameList();
    this.clearMobileLook();
  }

  gameCloseService(){
    this.iframePostMessage({message: 'CLOSE_GAME'});
    if(this.isMobile) {
      this.eventsService.publish("event:empty:gamedata"); // to set empty live dealer game
    }
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.getSessionToken(),
      game_launcher_id: "-1",
    };

    this.webservices.post("games/close-game", obj).subscribe(() => {
      this.gameHubControllerService.removeInstance(this.instanceId);
    });

    this.eventsService.publish("event:game:close");
    try {
      if (this.isMobile) {
        this.eventsService.publish('event:tracker:gameClosed');
      }
    } catch (e) {
      console.log("Error", e)
    }

    this.lobbyNavigator.selectActiveCasinoKeyword();
    this.eventsService.publish("event:balanceState", { show: true });
    if (this.isCapacitor) {
      if (!!this.windowResizeSubscription)
        this.windowResizeSubscription.unsubscribe();
      this.eventsService.publish("event:bottommenu:show")
    }
    else if (this.isMobileOrMobileWeb) {
      this.eventsService.publish("event:siteheader:show");
    }
    window.removeEventListener('message', this.messageEventListener);
  }
}
